"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAvgDaysDurationEl = formatAvgDaysDurationEl;
const HOURS_PER_DAY = 24;
const MINUTES_PER_DAY = HOURS_PER_DAY * 60;
/** Μορφοποίηση μέσου χρόνου που το API επιστρέφει σε ημέρες (δεκαδικό). */
function formatAvgDaysDurationEl(days) {
    if (days == null || !Number.isFinite(days) || days < 0)
        return '—';
    if (days >= 1) {
        const rounded = Math.round(days * 10) / 10;
        return `${rounded} ημ.`;
    }
    const hours = days * HOURS_PER_DAY;
    if (hours >= 1) {
        const rounded = Math.round(hours * 10) / 10;
        return `${rounded} ώρ.`;
    }
    const minutes = Math.round(days * MINUTES_PER_DAY);
    return `${minutes} λεπ.`;
}
